import MDAlert from "components/MDAlert";
import DataTable from "components/Tables/DataTable/DataTable";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import useDataUploadsTable from "hooks/organization/dataUploads/useDataUploadsTable";

export default function Index() {
  const { loading, error, tableData, pagination, filtering } = useDataUploadsTable();

  return (
    <>
      {(loading || error) && (
        <div style={{ padding: "16px" }}>
          {loading && <TableSkeleton numberOfLines={pagination.pageSize} />}
          {error && <MDAlert color="error">{error.message}</MDAlert>}
        </div>
      )}
      {!loading && !error && (
        <DataTable table={tableData} pagination={pagination} filtering={filtering} />
      )}
    </>
  );
}
